import React from 'react';
import { getDynamicPanelsUser, getDynamicPanelHomeUser } from '../../../services/dynamicPanels';
import { useQuery } from '@tanstack/react-query';

export const useDynamicPanelsUser = ({ enabled, favourites = false }) => {
  return useQuery({
    queryKey: ['dynamicPanelsUser', { favourites }],
    queryFn: async () => {
      return await getDynamicPanelsUser({ favourites });
    },
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

export const useDynamicPanelHomeUser = ({ enabled = true, refetchInterval } = {}) => {
  return useQuery({
    queryKey: ['dynamicPanelHomeUser'],
    queryFn: async () => {
      return await getDynamicPanelHomeUser();
    },
    enabled,
    staleTime: 0,
    cacheTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...(refetchInterval && { refetchInterval }),
  });
};
